$(document).ready(function(){

	// // -- Dropdown --
	// $(document).on('click', '.dropdown-toggle', function(e){
	// 	e.preventDefault();
	// 	$('.dropdown').removeClass('open');
	// 	$(this).parent('.dropdown').toggleClass('open');
	// });

	// -- Dropdown main menu --
	$(document).on('click', 'li.parent', function(e){
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
		} else {
			$('.main__nav li.parent').removeClass('open');
			$(this).toggleClass('open');			
		}
	});

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('navmenu--open');
		$(this).toggleClass('is-active');
	});

	$('.main__nav li a:not(.dropdown-toggle)').on('click', function(){
		$('body').removeClass('navmenu--open');
		$('.hamburger').removeClass('is-active');
	});

	// -- Hamburger text --
	$('.navbar__hamburgerMenu .text').on('click', function(){
		$('body').toggleClass('navmenu--open');
		$(this).next('.hamburger').toggleClass('is-active');
	});

});

// // -- Close dropdown when click outside --
// $(document).mouseup(function(e) {
//   var container = $('.dropdown-toggle');
//   if (!container.is(e.target) && container.has(e.target).length === 0) {
// 		$('.dropdown').removeClass('open');
//   }
// });


// -- Header fixed --
$(document).on('scroll', function(){
	var scrollTop = $(this).scrollTop();
	var header = $('.header').outerHeight();
	if (scrollTop > header) {
		$('body').addClass('header--fixed');
	} else {
		$('body').removeClass('header--fixed');
	}
});